var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"tags-breadcrumb-list",attrs:{"separator":"/"}},[_vm._l((_vm.tagCurrent),function(item,index){return [_c('el-breadcrumb-item',{attrs:{"to":{ path: item.value }}},[_vm._v(_vm._s(item.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }